import React from "react";

import { Props } from "./types";

function LockIcon(props: Props) {
  return (
    <svg className={props.className} viewBox="0 0 31.5 36">
      <path d="M28.125,15.75H26.438V10.688a10.688,10.688,0,0,0-21.375,0V15.75H3.375A3.376,3.376,0,0,0,0,19.125v13.5A3.376,3.376,0,0,0,3.375,36h24.75A3.376,3.376,0,0,0,31.5,32.625v-13.5A3.376,3.376,0,0,0,28.125,15.75Zm-7.312,0H10.688V10.688a5.063,5.063,0,0,1,10.125,0Z" />
    </svg>
  );
}

export { LockIcon };
